import { ReactElement, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ContextProps, createContext } from '../common/contextHelper'
import { LocalStorageItem } from '../common/constants'
import { deleteCookie } from '../common/helpers'
import { api } from '../services'

interface AuthContextState {
  isAuthorized: boolean | undefined
  authInProgress: boolean
  signOutInProgress: boolean
  error: string
  signIn: (email: string, password: string) => Promise<any>
  signOut: () => void

  email: string
  setEmail: (email: string) => void
}

const [Provider, useAuthContext] = createContext<AuthContextState>(module.filename)

export { useAuthContext }

export function AuthProvider({ children }: ContextProps): ReactElement {
  const navigate = useNavigate()

  const [isAuthorized, setIsAuthorized] = useState<boolean>()
  const [authInProgress, setAuthInProgress] = useState(false)

  const [email, setEmail] = useState('')
  const [signOutInProgress, setSignOutInProgress] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    const email = localStorage.getItem(LocalStorageItem.email)
    setIsAuthorized(!!email)
    if (email) {
      setEmail(email)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  async function signIn(email: string, password: string) {
    try {
      setError('')
      setAuthInProgress(true)
      setIsAuthorized(false)

      const { access_token } = await api.signIn(email, password)
      localStorage.setItem(LocalStorageItem.token, access_token)

      // await fetchAllDevicesForAccount(email)

      setEmail(email)
      localStorage.setItem(LocalStorageItem.email, email)

      setIsAuthorized(true)
    } catch (error: any) {
      setIsAuthorized(false)
      setError(error.response.data.error)
    } finally {
      setAuthInProgress(false)
    }
  }

  function signOut() {
    // TODO: clear cookie that holds the JWT?
    setSignOutInProgress(true)
    localStorage.removeItem(LocalStorageItem.username)
    localStorage.removeItem(LocalStorageItem.token)
    localStorage.removeItem(LocalStorageItem.email)
    deleteCookie('token')
    setEmail('')
    setIsAuthorized(false)
    setSignOutInProgress(false)
    navigate('/login')
  }

  return (
    <Provider
      value={{
        isAuthorized,
        authInProgress,
        signOutInProgress,
        error,
        signIn,
        signOut,

        email,
        setEmail,
      }}
    >
      {children}
    </Provider>
  )
}
